export default {
    deviceRecentlySeen: [],
    recentlySeen: null,
    searchList: null,
    preferences: null,
    searchListIssued: null,
    recentlySeenIssued: null,
}